
const Modal = (props) => {
  const {visible, children, title, additionalChildren} = props;
  return (
      visible ? (
        <div className="modal-wrapper">
          <div className="alert-box big">
            {
              title && (
                <h1 className="title">{title}</h1>
            )}
            {children}
            {additionalChildren && <div className="button-container">{additionalChildren}</div>}
          </div>
        </div>
      ) :
      <></>
  );
};

export default Modal;
